import(/* webpackMode: "eager" */ "/opt/buildhome/repo/apps/web/app/error.tsx");
